








import Vue from 'vue'
import Dialog from '@/components/Dialog.vue'
import Confirmation from './Confirmation.vue'
export default Vue.extend({
  components: {
    appDialog: Dialog,
    appConfirmation: Confirmation,
  },
  props: {
    item: Object,
  },
})
